import { render, staticRenderFns } from "./ConfigurationEmailCampaigns.vue?vue&type=template&id=83341e30&"
import script from "./ConfigurationEmailCampaigns.vue?vue&type=script&lang=js&"
export * from "./ConfigurationEmailCampaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports